module.exports = __webpack_public_path__ + "lv.81e09ae90f40671e660d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/lv.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/lv.svg
// module chunks = styles